import { lazy } from 'react';

const module = import('./RichTextEditorImpl');

export const RichTextEditor = lazy(() => module.then((m) => ({ default: m.RichTextEditor })));
export const OnEnterPlugin = lazy(() => module.then((m) => ({ default: m.OnEnterPlugin })));
